import React from "react";
import styled from "styled-components";
import authorIconWhite from "../../../../../images/icon-contributor-white@2x.png";
import stockIconWhite from "../../../../../images/icon-stock-white@2x.png";
import authorIcon from "../../../../../images/icon-contributor-darkgrey@2x.png";
import stockIcon from "../../../../../images/icon-stock-darkgrey@2x.png";

const Icon = styled.img`
    width: 18px;
    height: 18px;
    margin-right: 10px;
`;

export const SearchResultIcon = ({type, isHighlighted}) => {
    const iconWhite = type === "AUTHOR" ? authorIconWhite : stockIconWhite;
    const icon = type === "AUTHOR" ? authorIcon : stockIcon;
    return <Icon alt={type} src={isHighlighted ? iconWhite : icon}/>
};